import { TIER3, TIERS } from "../constants";
import { SpendDebitCard } from "graphql/generated";

type filterDebitCardProps = {
  cards: SpendDebitCard[];
  isLite?: boolean;
  tier?: (typeof TIERS)[number];
  setDebitCards: React.Dispatch<React.SetStateAction<SpendDebitCard[]>>;
  setInactiveCards?: React.Dispatch<React.SetStateAction<SpendDebitCard[]>>;
  setActiveCards?: React.Dispatch<React.SetStateAction<SpendDebitCard[]>>;
};

export const filterDebitCards = ({
  cards,
  isLite,
  tier,
  setDebitCards,
  setInactiveCards,
  setActiveCards,
}: filterDebitCardProps) => {
  let active: SpendDebitCard[] = [];
  let inactive: SpendDebitCard[] = [];

  if (cards && cards.length) {
    cards.forEach((card: SpendDebitCard) => {
      switch (card.status?.toLowerCase()) {
        case "lost":
        case "stolen":
          if (isLite && tier !== TIER3) {
            inactive.push(card);
          }
          break;
        case "inactive":
        case "frozen":
          inactive.push(card);
          break;
        case "active":
          active.push(card);
          break;
      }
    });
  }
  setDebitCards([...active, ...inactive]);
  if (setInactiveCards && setActiveCards) {
    setInactiveCards(inactive);
    setActiveCards(active);
  }
};
